import React, { useMemo } from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { FieldGroup } from '@xsolla/ui-core';

import { SmsCustomization } from '../../../api';
import { b2bLocale } from '../../../utils';
import { TagSelector } from '../../ui';

type Props = {
  smsData: SmsCustomization;
  onChange: (activeTags: string[]) => void;
};

const HideBlock = styled.div`
  display: none;
`;

export const LanguageSelector = ({ smsData, onChange }: Props): JSX.Element => {
  const intl = useIntl();

  const tagOptions = useMemo(() => {
    return b2bLocale.reduce(
      (acc, item) => [
        ...acc,
        {
          name: item,
          active:
            smsData.filter((template) => template.locale === item).length === 1 || item === 'en',
          tagLabel: intl.formatMessage({ id: `form.language.${item}` }),
          notChange: item === 'en'
        }
      ],
      []
    );
  }, []);
  // TODO блок скрыт. Необходимо выяснить можно ли как-то удалять переводы для языков и нужно ли это вообще
  return (
    <HideBlock>
      <FieldGroup
        label={intl.messages['user-data-base.settings.supplementary-info.fields-additional']}
        size="md">
        <Field name="fields">
          {({ input }) => {
            const changeInput = (activeTags: string[]) => {
              onChange(activeTags);
              input.onChange(activeTags);
            };
            return <TagSelector options={tagOptions} onChange={changeInput} />;
          }}
        </Field>
      </FieldGroup>
    </HideBlock>
  );
};
